import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import Card from '../Common/Card/Card'

import './ManageCustomer.scss'
import MobileHeader from '../Common/Header/MobileHeader'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import { convertToTitleCase } from '../../common/utils/appUtils'
import { navigate } from '../../common/utils/redirectionUtils'
import {
  ACTIVE_STATUS,
  PAGE_CONST,
  PERMISSION_FEATURE,
  PERMISSION_SCREEN,
  PERMISSION_TYPE,
} from '../../common/constant/page-constant'
import {
  HEADER_CONFIG,
  HEADER_CONST,
} from '../../common/constant/common-constant'
import SearchIcon from '../../assets/SearchIcon'
import CloseIcon from '../../assets/CloseIcon'
import {
  getAllCustomersHelper,
  updateCustomerHelper,
} from '../../helper/settings-helper'
import './ManageCustomer.scss'

const ManageCustomer = (props) => {
  const isMobile = useCheckMobileScreen()
  const inputRef = useRef()

  const [headerOptions, setHeaderOptions] = useState({
    [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
    [HEADER_CONFIG.TITLE]: HEADER_CONST.MANAGE_CUSTOMER,
    [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => props?.onBackClick(),
  })
  const [loginData, setLoginData] = useState({})
  const [manageCustomerData, setManageCustomerData] = useState([])
  const [filteredManageCustomerData, setFilteredManageCustomerData] = useState(
    []
  )
  const [viewSearch, setViewSearch] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [permissions, setPermissions] = useState({})

  useEffect(() => {
    getCustomerData()
  }, [])

  useEffect(() => {
    setLoginData(props.loginData)

    if (props.loginData.permissions) {
      console.log('props.loginData.permissions: ', props.loginData.permissions)

      let permission = props.loginData.permissions.filter(
        (permission) => permission.screen === PERMISSION_SCREEN.SETTINGS
      )[0]

      if (permission) setPermissions(permission)
    }
  }, [props.loginData])

  useEffect(() => {
    let filteredStoreData = manageCustomerData.filter(
      (customer) =>
        customer?.mobile_no
          ?.toUpperCase()
          ?.includes(searchTerm?.toUpperCase()) ||
        customer?.name?.toUpperCase()?.includes(searchTerm?.toUpperCase())
    )

    setFilteredManageCustomerData(filteredStoreData)
  }, [searchTerm])

  const getCustomerData = async () => {
    try {
      let data = await getAllCustomersHelper()
      setManageCustomerData(data)
      setFilteredManageCustomerData(data)
    } catch (err) {
      console.log('err: ', err)
    }
  }

  const expandSearch = () => {
    inputRef.current.focus(setViewSearch(true))
  }

  const hanleCardActtion = async (id, action) => {
    console.log('action clicked !!', action)

    try {
      let status = action === ACTIVE_STATUS.ACTIVE
      await updateCustomerHelper(id, status)
      getCustomerData()
    } catch (err) {
      console.log('err: ', err)
    }
  }

  return (
    <>
      {isMobile && <MobileHeader headerOptions={headerOptions} />}
      <div className="pageBodyRightPanel">
        {isMobile && (
          <div className="addProductBtnMobile dFlex aiCenter mwebVisible fixed">
            <div
              className={'formGroup mb-0 searchBar expand'}
              onClick={expandSearch}
              onBlur={() => setViewSearch(false)}
            >
              <input
                ref={inputRef}
                type="text"
                className="formControl"
                placeholder="Search Consumer Name/Number"
                onChange={(e) => setSearchTerm(e?.target?.value)}
              />
              <div className={`searchIcon`}>
                <SearchIcon />
              </div>
            </div>
          </div>
        )}
        {!isMobile && (
          <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter mb-5">
            <div className="pageBodyRightPanelHeading">Manage Consumer</div>
            <div className="addProductBtn dFlex aiCenter">
              <div
                className={`formGroup mb-0 searchBar expand`}
                onClick={expandSearch}
                onBlur={() => setViewSearch(false)}
              >
                <input
                  ref={inputRef}
                  type="text"
                  className="formControl"
                  placeholder="Search Consumer Name/Number"
                  onChange={(e) => setSearchTerm(e?.target?.value)}
                />
                <div className={`searchIcon`}>
                  <SearchIcon />
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="productLlistWrap dFlex">
          {filteredManageCustomerData?.map((customer) => {
            return (
              <div className="cardWrap">
                <Card
                  userInitials={convertToTitleCase(customer?.name?.[0])}
                  headerSup={customer.name}
                  headerMain={`ID: ${customer.id}`}
                  phone={customer.mobile_no}
                  email={customer.email}
                  rating={customer.rating}
                  location={customer.address}
                  isActive={customer.is_active}
                  cardAction={
                    permissions?.features?.[
                      PERMISSION_FEATURE.PHARMACY_STORE
                    ] === PERMISSION_TYPE.MANAGE &&
                    (customer.is_active
                      ? [ACTIVE_STATUS.INACTIVE]
                      : [ACTIVE_STATUS.ACTIVE])
                  }
                  onCardAction={(action) =>
                    hanleCardActtion(customer.id, action)
                  }
                />
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    // alert: state.alertReducer.alert,
    loginData: state.loginDataReducer?.loginData,
  }
}

const mapDispatchToProps = (dispatch) => {}

export default connect(mapStateToProps, mapDispatchToProps)(ManageCustomer)
